import { useState, useEffect, useCallback } from 'react';
import { JOKI } from '../../JOKI';

export default function useGraphQuery(dataCompiler = undefined, renewQuery = false) {
    const [data, setData] = useState([]);
    const [error, setError] = useState(false);

    const [lastUpdated, setLastupdated] = useState(0);

    useEffect(() => {
        let didCancel = false;

        async function loadGraphQuery() {
            try {
                const results = await JOKI.ask({
                    to: 'DevicesService',
                    key: 'getDeviceInventoryList',
                    body: {},
                });

                results.DevicesService.then(res => {
                    setData(res.allDevices);
                    setLastupdated(Date.now());
                }).catch(err => {
                    console.error('GRAPHQL DEVICE INVENTORY LOADING FAILED!', err);
                    setError({ message: err.message, stage: 'loading report', error });
                    setData([]);
                });
                   
            } catch (err) {
                console.warn('Could not load GraphQL Device Inventory Data', err);
                setError({ message: err.message || err.msg || 'General endpoint/service/joki error', stage: 'loading report ', error });
                setData([]);
            }
        }

        if (lastUpdated + 1000 * 60 < Date.now()) {
            setData(null);
            loadGraphQuery();
        }

        return () => {
            didCancel = true;
        };
    }, [lastUpdated]);

    const refresh = useCallback(() => {
        setLastupdated(0); // Updating last update time to 0 will start the loading process
    }, []);

    return [data, refresh];
}
